import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import {HttpClientModule} from '@angular/common/http';
import { EnvironmentComponent } from './environment';

@NgModule({
    imports: [SharedModule, HttpClientModule ],
    declarations: [EnvironmentComponent],
    entryComponents: [EnvironmentComponent],
    exports: [EnvironmentComponent],
    providers: [ Utils]
})

export class EnvironmentModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/environments-ang7/environment/environment.module.ts